<template>
  <f7-block-title>Products</f7-block-title>
  <f7-list>
    <Product
      v-for="(product, i) in products"
      :key="i"
      :product="product"
    ></Product>
  </f7-list>
</template>

<script>
import Product from "@/components/Sidebar/Product.vue";

export default {
  name: "SidebarSidebar",
  components: { Product },
  props: {
    products: Array
  }
};
</script>
